// extracted by mini-css-extract-plugin
export var searchModalHeaderStyle = "search_instant_dropdown-module--searchModalHeaderStyle--WigoV";
export var searchResultWrapperStyle = "search_instant_dropdown-module--searchResultWrapperStyle--MyV3P";
export var searchWrapperStyle = "search_instant_dropdown-module--searchWrapperStyle--cjr5G";